
export { BricksApiService } from './lib/bricks-api.service';
export * from './lib/brick-api.module';

